import { Vue, Component, Prop } from 'vue-property-decorator'
import { getPlatformById } from '@/helpers/getPlatformById'
import { ImageTransform } from '@/types/image'
import { Platform, ProjectID } from '@/types/platform'

@Component
export default class SAvatar extends Vue {
  @Prop({ type: String }) private readonly imageSrc?: string
  @Prop({ type: Object }) private readonly imageTransform?: ImageTransform

  @Prop({ type: Number })
  private readonly projectId?: ProjectID

  @Prop({ type: String, default: Platform.im })
  private readonly projectName!: Platform

  private get localImageSrc() {
    const projectName = this.projectId
      ? getPlatformById(this.projectId)
      : this.projectName

    return this.imageSrc || require(`@/assets/images/${projectName}_small.jpeg`)
  }
}
